import { TInviteRequest } from '@gen2/api/invite-requests/api';
import { create } from 'zustand';

export interface IRequestsStore {
  toDeleteRequest?: TInviteRequest;
  activeRequest: TInviteRequest | null;
  expandedGroups: Set<string>;
  setToDeleteRequest: (req?: TInviteRequest) => void;
  setActiveRequest: (req: TInviteRequest | null) => void;
  toggleGroupExpansion: (groupId: string) => void;
}

const defaultRequestsState = {
  selectedRequest: {} as TInviteRequest,
  activeRequest: null,
  expandedGroups: new Set<string>(),
  requests: [],
};

export const useRequestsStore = create<IRequestsStore>()((set, get) => ({
  // state
  ...defaultRequestsState,

  // actions
  setToDeleteRequest: (req) => set({ toDeleteRequest: req }),
  setActiveRequest: (req) => set({ activeRequest: req }),
  toggleGroupExpansion: (groupId) => {
    const { expandedGroups } = get();
    const newExpandedGroups = new Set(expandedGroups);
    if (newExpandedGroups.has(groupId)) {
      newExpandedGroups.delete(groupId);
    } else {
      newExpandedGroups.add(groupId);
    }
    set({ expandedGroups: newExpandedGroups });
  },
}));
